import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    borderRadius: 4,
    backgroundColor: `${theme.palette.tertiary.light}50`,
    padding: `${theme.spacing(4)}px 0`,
  },
  text: {
    fontSize: '40px!important',
    fontWeight: 600,
    letterSpacing: 1,
    fontFamily: 'Bebas, Lato',
    color: `${theme.palette.black}db`,
  },
})

const CodeBox = ({ classes, className, code }) => (
  <div className={classNames(classes.root, className)}>
    <Typography className={classes.text}>{code}</Typography>
  </div>
)

CodeBox.propTypes = {
  code: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(CodeBox)



// WEBPACK FOOTER //
// ./src/components/atoms/CodeBox.js